import React, { createContext, useState, useCallback } from 'react';
import { toast } from 'react-toastify';
import { getCoinRequests, deleteCoinRequest } from '../services/api';

export const CoinRequestContext = createContext();

export const CoinRequestProvider = ({ children }) => {
  const [requests, setRequests] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchRequests = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await getCoinRequests();
      setRequests(response.data);
    } catch (err) {
      const errorMessage = err.response?.data?.message || 'خطا در دریافت درخواست‌ها';
      setError(errorMessage);
      toast.error(errorMessage);
    } finally {
      setLoading(false);
    }
  }, []);

  const removeRequest = useCallback(async (id) => {
    setLoading(true);
    setError(null);
    try {
      await deleteCoinRequest(id);
      setRequests((prev) => prev.filter((req) => req.id !== id));
      toast.success('درخواست با موفقیت حذف شد');
    } catch (err) {
      const errorMessage =
        err.response?.status === 404
          ? 'درخواست مورد نظر یافت نشد'
          : err.response?.data?.message || 'خطا در حذف درخواست';
      setError(errorMessage);
      toast.error(errorMessage);
      throw err;
    } finally {
      setLoading(false);
    }
  }, []);

  return (
    <CoinRequestContext.Provider
      value={{
        requests,
        loading,
        error,
        fetchRequests,
        removeRequest,
      }}
    >
      {children}
    </CoinRequestContext.Provider>
  );
};